// Capture jQuery at load time. App scripts (e.g. Easy Product Addons' $SGJquery)
// call jQuery.noConflict(true) which can strip window.$ / window.jQuery before our
// handlers bind, leaving the form doing a native GET submit (page refresh + cleared
// fields). Everything below uses this captured reference instead of the global.
(function ($) {
if (!$ || !$.fn) {
    console.error('calculator.js: jQuery not available at load time - calculator disabled');
    return;
}

// phone number field
document.addEventListener("DOMContentLoaded", function() {
    // Guarded: if the intl-tel-input CDN fails or another script interferes,
    // the phone widget is skipped but the rest of the calculator still works.
    try {
        const phoneInput = document.querySelector("#phone");
        window.iti = window.intlTelInput(phoneInput, {
            initialCountry: "au",  // Default to Australia
            separateDialCode: true,
            preferredCountries: ["au", "nz", "us", "gb"],
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.1.1/build/js/utils.js" // Format helper
        });
    } catch (e) {
        console.error('calculator.js: phone input init failed', e);
    }

    // Prevent scroll wheel from changing number input values
    document.addEventListener('wheel', function(e) {
        if (document.activeElement.type === 'number') {
            document.activeElement.blur();
        }
    });
});

// main calculator logic

//genric class
var mrk_inputs = $('.mrk-input');
//arrays of radiators range
var radiator_range = [
    {
        min: "0",
        max: "300",
        no_of_heaters: "1",
        Heater_1: "250W Radiator"
    },
    {
        min: "301",
        max: "600",
        no_of_heaters: "1",
        Heater_1: "500W Radiator"
    },
    {
        min: "601",
        max: "800",
        no_of_heaters: "1",
        Heater_1: "750W Radiator"
    },
    {
        min: "801",
        max: "1100",
        no_of_heaters: "1",
        Heater_1: "1000W Radiator"
    },
    {
        min: "1101",
        max: "1300",
        no_of_heaters: "1",
        Heater_1: "1250W Radiator"
    },
    {
        min: "1301",
        max: "1600",
        no_of_heaters: "1",
        Heater_1: "1500W Radiator"
    },
    {
        min: "1601",
        max: "2150",
        no_of_heaters: "1",
        Heater_1: "2000W Radiator"
    },
    {
        min: "2151",
        max: "2300",
        no_of_heaters: "1",
        Heater_1: "1000W Radiator",
        Heater_2: "1250W Radiator"
    },
    {
        min: "2301",
        max: "2600",
        no_of_heaters: "2",
        Heater_1: "1250W Radiator"
    },
    {
        min: "2601",
        max: "2850",
        no_of_heaters: "1",
        Heater_1: "1250W Radiator",
        Heater_2: "1500W Radiator"
    },
    {
        min: "2851",
        max: "3100",
        no_of_heaters: "2",
        Heater_1: "1500W Radiator"
    },
    {
        min: "3101",
        max: "3300",
        no_of_heaters: "1",
        Heater_1: "1250W Radiator",
        Heater_2: "2000W Radiator"
    },
    {
        min: "3301",
        max: "3600",
        no_of_heaters: "1",
        Heater_1: "1500W Radiator",
        Heater_2: "2000W Radiator"
    },
    {
        min: "3601",
        max: "4100",
        no_of_heaters: "2",
        Heater_1: "2000W Radiator"
    }
]
//variables
var room_size = $('[name="room-total"]');
external_walls_length = $('[name="external-walls-manual"]'),
    windows_area = $('[name="size-of-windows-manual"]'),
    total_area_manual = $('#total_area_manual'),
    total_window_manual = $('#total_window_manual'),
    external_wall_area_manual = $('#external-walls-manual'),
    external_wall_checked = $('#external_wall_custom');

const room_type = $('[name="room-type"]'),
    room_length = $('[name="room-length"]'),
    room_width = $('[name="room-width"]'),
    room_height = $('[name="room-height"]');

//walls
const no_of_external_walls = $('[name="external-walls"]');

//windows
const no_of_windows = $('[name="no-of-windows"]'),
    size_of_windows = $('[name="size-of-windows"]');

//doors
const no_of_doors = $('[name="no-of-external-doors"]');

//insulation 
const walls_insulation = $('[name="walls-insulation"]'),
    ceiling_insulation = $('[name="ceilings-insulation"]'),
    floor_insulation = $('[name="floors-insulation"]'),
    windows_insulation = $('[name="windows-insulation"]');

//insulation custom variables
var walls_custom_insulation = $('[name="custom-r-value-walls"]'),
    ceiling_custom_insulation = $('[name="custom-r-value-ceilings"]'),
    floor_custom_insulation = $('[name="custom-r-value-floors"]'),
    windows_custom_insulation = $('[name="custom-r-value-windows"]');

//others
const room_draughty = $('[name="room-draughty"]'),
    carpet = $('[name="room-carpet"]'),
    room_flores = $('[name="room-flore"]'),
//postal
    postal_code = $('[name="postal-code"]'),
    heatup_factor = .2, //20%,
    largest_heater = '2000W Radiator',
    Watt_cut_off_for_calc = 6000;
var watt_require = 0;
window.mrk = {};
const mrk_recommended = window.mrk_recommended_products;
// functions
const n = (x) => {
    return Number(x);
}
const mrk_round = (x) => {
    return n(x.toFixed(2))
}
const room_size_update = () => {
    let size;
    if (total_area_manual.is(':checked')) {
        size = n(room_size.val()) || 0;
    } else {
        size = (n(room_length.val()) || 0) * (n(room_width.val()) || 0);
    }
    return size;
}
const external_wall_length = (size) => {
    if (external_wall_checked.is(':checked'))
        var walls = n(external_wall_area_manual.val()); // n(external_walls_length.val());
    else
        var walls = Math.sqrt(size) * n(no_of_external_walls.val());
    return walls
}
const cubic_meter = (size, height) => {
    var cubic_meter_val = size * height;
    // console.log(cubic_meter_val, size, height);
    return cubic_meter_val
}
const windowSize = () => {
    var size = n(size_of_windows.val());
    return size
}
const windowArea = () => {
    if (total_window_manual.is(':checked'))
        var final_area = n(windows_area.val());
    else
        var final_area = n(no_of_windows.val()) * n(size_of_windows.val());
    return final_area
}
const doorArea = () => {
    var door_area = n(no_of_doors.val()) * (2.2 * 0.82);
    return door_area
}
const externalWallArea = (room_height, external_wall_length, window_area, door_area) => {
    if ((room_height * external_wall_length) - (window_area + door_area) < 0) {
        return 0
    } else {
        // console.log((room_height*external_wall_length)-(window_area+door_area));
        return mrk_round((room_height * external_wall_length) - (window_area + door_area))
    }
}
const setPostalData = () => {
    if (localStorage.getItem('Postal Data') == null) {
        $.ajax({
            type: "GET",
            url: '/pages/postal-data?view=postal_data',
            dataType: "html",
            success: function (response) {
                var data = JSON.parse(response);
                var data_string = JSON.stringify(data);
                localStorage.setItem('Postal Data', data_string);
            }
        });
    }
}
const TempFormula = () => {
    var postal_data = JSON.parse(localStorage.getItem('Postal Data')),
        num = n(postal_code.val()),
        temperature = 0;
    postal_data.forEach(e => {
        if (num >= e.min && num <= e.max) {
            temperature = n(e.value);
            return false;
        }
    });
    return temperature
}
const DesiredTemperature = () => {
    return n(room_type.val());
}
const deltaT = (desire_t, postal_value) => {
    return desire_t - postal_value
}
const wallU = () => {
    if (walls_custom_insulation.val() != '') {
        return 1 / n(walls_custom_insulation.val())
    } else {
        return n(walls_insulation.val())
    }
}
const windowU = () => {
    if (windows_custom_insulation.val() != '') {
        return n(windows_custom_insulation.val())
    } else {
        return n(windows_insulation.val())
    }
}
const floorU = (FloorBonusR, CarpetBonusR) => {
    if (floor_custom_insulation.val() != '') {
        return 1 / (n(floor_custom_insulation.val()) + FloorBonusR + CarpetBonusR)
    } else {
        var floorU = 1 / (1 / n(floor_insulation.val()) + FloorBonusR + CarpetBonusR)
        return floorU
    }
}
const CeilingU = (CeilingBonusR) => {
    if (ceiling_custom_insulation.val() != '') {
        return 1 / (n(ceiling_custom_insulation.val()) + CeilingBonusR)
    } else {
        return 1 / (1 / n(ceiling_insulation.val()) + CeilingBonusR)
    }
}
const extraRadiators = (watt_require) => {
    if (watt_require <= 4100) {
        return 0
    } else {
        return mrk_round((watt_require / 2000) - 1)
    }
}
const overflowWatts = (watt_require, extra_2000_radiators) => {
    if (watt_require > 4100) {
        return (watt_require - (2000 * extra_2000_radiators))
    } else {
        return watt_require
    }
}
const heater1 = (watt_require) => {
    var name = '';
    if (watt_require > Watt_cut_off_for_calc) {
        name = largest_heater
    } else {
        radiator_range.forEach(line => {
            var min = n(line.min),
                max = n(line.max);
            if (watt_require >= min && watt_require <= max) {
                name = line.Heater_1;
                return false
            }
        });
    }
    return name
}
const heater2 = (watt_require, heater_1, extra_2000_radiators) => {
    var name = '';
    if (watt_require > Watt_cut_off_for_calc) {
        name = ''
    } else {
        radiator_range.forEach(line => {
            var min = n(line.min),
                max = n(line.max);
            if (heater_1 != largest_heater && extra_2000_radiators == 0) {
                if (watt_require >= min && watt_require <= max && line.Heater_2 != '') {
                    name = line.Heater_2;
                    return false
                }
            }
        });
    }
    return name
}
const heater1Qty = (watt_require, heater_1, extra_2000_radiators) => {
    var qty = 0;
    if (watt_require > Watt_cut_off_for_calc) {
        return Math.round(watt_require / 2000)
    } else {
        if (heater_1 == largest_heater && extra_2000_radiators > 0) {
            radiator_range.forEach(line => {
                var min = n(line.min),
                    max = n(line.max);
                if (watt_require >= min && watt_require <= max) {
                    qty = n(line.no_of_heaters) + extra_2000_radiators
                }
            });
        } else {
            radiator_range.forEach(line => {
                var min = n(line.min),
                    max = n(line.max);
                if (watt_require >= min && watt_require <= max) {
                    qty = n(line.no_of_heaters)
                }
            });
        }
        return qty
    }
}
const heater2Qty = (watt_require, heater_2, extra_2000_radiators) => {
    var qty = 0;
    if (watt_require > Watt_cut_off_for_calc) {
        return ''
    } else {
        if (heater_2 == radiator_range && extra_2000_radiators > 0) {
            qty = extra_2000_radiators
        } else {
            if (heater_2 == '') {
                qty = '';
            } else {
                qty = 1
            }
        }
        return qty
    }
}


$('.room-size-input').on('change keyup input', function () {
    var area = room_size_update();
    room_size.val(mrk_round(area));
});
$('.window-size-input').on('change keyup input', function () {
    var window_area = windowArea();
    windows_area.val(mrk_round(window_area));
});

var form = $('.mrk-calculator-form');
var elements = form[0].elements;

$(elements).on('invalid', function(event) {
    $(this).addClass('calculatorInvalid'); // Add the 'calculatorInvalid' class to all invalid inputs for styling
    $(this)[0].scrollIntoView({
        behavior: 'smooth',
        block: 'center'
    });
    $(this).focus();

});

$(elements).on('input', function(event) {
    // Remove the 'calculatorInvalid' class once the input is valid
    if (this.checkValidity()) {
        $(this).removeClass('calculatorInvalid');
    }
});

function additionalValidation () {

    // phone number field
    const phoneInput = document.querySelector("#phone");
    // If the phone widget failed to init, skip strict validation rather than crash
    const isValid = window.iti ? window.iti.isValidNumber() : true;
    const phoneNumber = phoneInput.value.trim();

    if (phoneNumber.length > 0 && !isValid) {
        $(phoneInput).addClass('calculatorInvalid');
        phoneInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        phoneInput.focus();
        return false
    } else {
        $(phoneInput).removeClass('calculatorInvalid');
        return true
    }
}

function hideProductsWithoutVisibleProductItems () {
    $('.mrk-final-products .product-item-wrapper').each(function () {
        if ($(this).find('.product-item:not([style*="display: none"])').length === 0) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
}

$('.mrk-calculator-form').on('submit', function (e) {
    e.preventDefault();

    const isValid = additionalValidation();
    if (!isValid) return

    // debugger;
    var area = room_size_update(),
        height = n(room_height.val()),
        walls = external_wall_length(area),
        cubic_meter_val = cubic_meter(area, height),
        //windows
        window_size = windowSize(),
        window_area = windowArea(),
        door_area = doorArea(),
        external_wall_area = externalWallArea(height, walls, window_area, door_area),
        //Temp Formula
        tem_formula = TempFormula(),
        desire_temprature = DesiredTemperature(),
        delta_T = deltaT(desire_temprature, tem_formula),
        CarpetBonusR = n(carpet.val()),
        CeilingBonusR = n(room_flores.val()),
        FloorBonusR = n(room_flores.find('option:selected').attr('floor_bonus')),
        wall_u = wallU(),
        windowU_u = windowU(),
        floor_u = floorU(FloorBonusR, CarpetBonusR),
        ceiling_u = CeilingU(CeilingBonusR),
        door_u = n(windows_insulation.val()),
        air_intrusion_rate = n(room_draughty.val()),
        // heat losses
        wall_heat_loss = external_wall_area * delta_T * wall_u,
        window_heat_loss = window_area * delta_T * windowU_u,
        floor_heat_loss = area * delta_T * floor_u,
        ceiling_heat_loss = area * delta_T * ceiling_u,
        door_heat_loss = door_area * delta_T * door_u,
        intrusion_heat_loss = 0.33 * cubic_meter_val * delta_T * air_intrusion_rate,
        total_heat_loss = wall_heat_loss + window_heat_loss + floor_heat_loss + ceiling_heat_loss + door_heat_loss + intrusion_heat_loss,
        watt_require = total_heat_loss + (heatup_factor * total_heat_loss),
        rec_w_per_m_square = mrk_round(watt_require / cubic_meter_val);
    extra_2000_radiators = extraRadiators(watt_require),
        overflow_watts = overflowWatts(watt_require, extra_2000_radiators),
        heater_1 = heater1(watt_require),
        heater_2 = heater2(watt_require, heater_1, extra_2000_radiators),
        heater_1_qty = heater1Qty(watt_require, heater_1, extra_2000_radiators),
        heater_2_qty = heater2Qty(watt_require, heater_2, extra_2000_radiators)

    // console.log(extra_2000_radiators, overflow_watts, heater_1, heater_2, heater_1_qty, heater_2_qty);

    if (watt_require != 0) {
        $('.final-watt-required').text(`${Math.round(watt_require)} W`)
    }
    if (heater_1 != '' && heater_1 != undefined) {
        $('.mrk-first-radiator-name').html(heater_1);
        $('.mrk-first-radiator-qty').html(heater_1_qty);
    } else {
        $('.mrk-first-radiator-name').html('');
        $('.mrk-first-radiator-qty').html('');
    }
    if (heater_2 != '' && heater_2 != undefined) {
        $('.mrk-second-radiator-name').html(heater_2);
        $('.mrk-second-radiator-qty').html(heater_2_qty);
    } else {
        $('.mrk-second-radiator-name').html('');
        $('.mrk-second-radiator-qty').html('');
    }
    var find_heaters = heater_1;
    var wattage_1 = heater_1.replace(" Radiator", "")

    if (heater_2 != '' && heater_2 != undefined) {
        find_heaters = find_heaters + ', ' + heater_2;
        var wattage_2 = heater_2.replace(" Radiator", "")
    }

    // product level
    $('.mrk-final-products .product-item').each(function () {
        var to_find_heater_1 = wattage_1,
            to_find_heater_2 = wattage_2 || '';
        var attr = $(this).attr('data-wattage');

        /*
            Product Visibility Logic
            Product is visible if it matches the heater wattage AND exclusions don't apply
         */
        let visible = attr == to_find_heater_1 || attr == to_find_heater_2

        const product_name = $(this).attr('data-product-filter-name')
        const room_type = $('#room-type option:selected').text()

        // Tahiti only visible for bathroom, kitchen, or other
        if (product_name === 'Tahiti Surf Electric Towel Rail' && !['Bathroom/Toilet', 'Kitchen', 'Other'].includes(room_type)) {
            visible = false
        }

        // Kaba not visible for bathroom
        if (product_name === 'Kaba' && room_type === 'Bathroom/Toilet') {
            visible = false
        }

        if (visible) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
    // variant level
    $('.mrk-final-products .PDPSizeList__Item').each(function () {
        var to_find_heater_1 = wattage_1,
            to_find_heater_2 = wattage_2 || '';
        var attr = $(this).attr('data-wattage');
        var parentAttr = $(this).attr('data-wattage-parent');
        if (attr == parentAttr && (attr == to_find_heater_1 || attr == to_find_heater_2)) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    //$('.mrk-rec-products').slideDown();
    hideProductsWithoutVisibleProductItems();
    $('#final-recommendation-row').show();

    // scroll to the results #final-recommendation-row
    $('html, body').animate({
        scrollTop: $('#final-recommendation-row').offset().top - 150
    },  1000);


    // $('.calculator-email-estimate-form').show();

    // send the estimate if they've put in an email
    sendEstimate();
});

// hide the room_name field if the email is empty, otherwise show it
$('#room_name_group').hide();
$('#email').on('change', function () {
    if ($(this).val() === '') {
        $('#room_name_group').hide();
    } else {
        $('#room_name_group').show();
    }
});

$('#total_area_manual').on('change', function () {
    if ($(this).is(':checked')) {
        $('[name="room-length"], [name="room-width"]').addClass('mrk-disabled').val('').removeAttr('required');
        $(room_size).removeClass('mrk-disabled').prop('required', true);
    } else {
        $('[name="room-length"], [name="room-width"]').removeClass('mrk-disabled').prop('required', true)
        $(room_size).addClass('mrk-disabled').removeAttr('required');
        $('[id="room-total-size"]').val('');
    }
});
$('#external_wall_custom').on('change', function () {
    if ($(this).is(':checked')) {
        $(no_of_external_walls).addClass('mrk-disabled').val('').removeAttr('required');
        $(external_walls_length).removeClass('mrk-disabled').prop('required', true);
    } else {
        $(no_of_external_walls).removeClass('mrk-disabled').prop('required', true)
        $(external_walls_length).addClass('mrk-disabled').removeAttr('required');
        $('[id="external-walls-manual"]').val('');
    }
});

$('#total_window_manual').on('change', function () {
    if ($(this).is(':checked')) {
        $('[name="no-of-windows"], [name="size-of-windows"]').val('').addClass('mrk-disabled').removeAttr('required');
        $(windows_area).removeClass('mrk-disabled').prop('required', true);
    } else {
        $('[name="no-of-windows"], [name="size-of-windows"]').removeClass('mrk-disabled').prop('required', true);
        $('[name="no-of-windows"]').val('0');
        $('[name="size-of-windows"]').val('0.5');
        $(windows_area).addClass('mrk-disabled').removeAttr('required');
        $('[id="size-of-windows-manual"]').val('');
    }
});

// Custom R Value Fields */
$(document).ready(function () {
    function enableCustomRValue(selectorCustom, selectorInsulation) {
        $(selectorCustom).removeClass('mrk-disabled-clickable').prop('required', true);
        $(selectorInsulation).val('').addClass('mrk-disabled-clickable').removeAttr('required');
    }

    function enableInsulation(selectorInsulation, selectorCustom) {
        $(selectorInsulation).removeClass('mrk-disabled-clickable').prop('required', true);
        $(selectorCustom).val('').addClass('mrk-disabled-clickable').removeAttr('required');
    }

    // Use event delegation on the parent Form__Item
    $('.Form__Item').on('click', '#walls-insulation, #custom-r-value-walls, #ceilings-insulation, #custom-r-value-ceilings, #floors-insulation, #custom-r-value-floors, #windows-insulation, #custom-r-value-windows', function () {
        const id = $(this).attr('id');

        if (id === 'custom-r-value-walls') {
            enableCustomRValue('#custom-r-value-walls', '[name="walls-insulation"]');
        } else if (id === 'walls-insulation') {
            enableInsulation('[name="walls-insulation"]', '#custom-r-value-walls');
        } else if (id === 'custom-r-value-ceilings') {
            enableCustomRValue('#custom-r-value-ceilings', '[name="ceilings-insulation"]');
        } else if (id === 'ceilings-insulation') {
            enableInsulation('[name="ceilings-insulation"]', '#custom-r-value-ceilings');
        } else if (id === 'custom-r-value-floors') {
            enableCustomRValue('#custom-r-value-floors', '[name="floors-insulation"]');
        } else if (id === 'floors-insulation') {
            enableInsulation('[name="floors-insulation"]', '#custom-r-value-floors');
        } else if (id === 'custom-r-value-windows') {
            enableCustomRValue('#custom-r-value-windows', '[name="windows-insulation"]');
        } else if (id === 'windows-insulation') {
            enableInsulation('[name="windows-insulation"]', '#custom-r-value-windows');
        }
    });
});


$('.variant-action-btns.QuantitySelector').each(function () {
    var input = $(this).find('.QuantitySelector__CurrentQuantity');
    var plus = $(this).find('[data-action="increase-quantity"]');
    var minus = $(this).find('[data-action="decrease-quantity"]');

    // set initial value
    $(input).val(0);

    $(plus).click(function () {
        var val = Number($(input).val());
        $(input).val(val + 1);
    });

    $(minus).click(function () {
        var val = Number($(input).val());
        if (val - 1 >= 0) {
            $(input).val(val - 1);
        }
    });
});

$('.Variant__AddToCart').each(function () {
    $(this).on('submit', function (e) {
        e.preventDefault();

        var btn = $(this).find('[data-action="add-to-cart"]');
        var variantId = btn.data('variant');

        // Find the quantity input within the same PDPSizeList__Item container
        var quantityInput = $(this).closest('.PDPSizeList__Item').find('.QuantitySelector__CurrentQuantity');
        var quantity = quantityInput.val();

        var formData = {
            'id': variantId,
            'quantity': quantity
        };

        // console.log('adding formData', formData);

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            dataType: 'json',
            beforeSend: function () {
                $(btn).addClass('mrk-loading');
                document.dispatchEvent(new CustomEvent('theme:loading:start'));
            },
            success: function () {
                $(btn).removeClass('mrk-loading');
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                    bubbles: true
                }));
            }
        });
    });
});

$(function () {
    setPostalData(); //AJAX request for postal data and set it to local storage
})

// extra reset link outside of form
document.addEventListener('DOMContentLoaded', function () {
    var resetLink = document.querySelector('.ResetContainer a');
    var form = document.getElementById('calculator');
    if (resetLink && form) {
        resetLink.addEventListener('click', function (event) {
            event.preventDefault();
            form.reset();

            // scroll back up
            var locationElement = document.getElementById('location');
            if (locationElement) {
                locationElement.scrollIntoView({
                    behavior: 'smooth'  // This makes the scroll animation smooth
                });
            }
        });
    }
});


// Helper function set default values for dev / testing
function setValueById(id, value) {
    // Find the element by its name attribute
    var element = document.querySelector(`[id="${id}"]`);

    // Check if the element exists
    if (element) {
        // Set the value of the element
        element.value = value;
    } else {
        console.error('Element not found with the name:', id);
    }
}

// Testing only
// setValueById('postal-code', '3000');
// setValueById('room-length', 5);
// setValueById('room-width', 6);
// setValueById('room-height', 5);
//
// setValueById('no-of-windows', 3);
// setValueById('size-of-windows', 1.9);
// setValueById('external-walls', 2);


// sticky sidebar on scroll
document.addEventListener("DOMContentLoaded", function () {
    const calculatorSide = document.querySelector('.Calculator__Side');
    const pageTitle = document.querySelector('.CalculatorPageTitle');

    function adjustCalculatorSidebarPosition() {
        const pageTitleBottom = pageTitle.getBoundingClientRect().height;

        //  window.innerHeight
        if (window.scrollY >= pageTitleBottom) {
            calculatorSide.classList.add('Calculator__Side--sticky');
        } else {
            calculatorSide.classList.remove('Calculator__Side--sticky');
        }
    }

    // Listen to the scroll event
    window.addEventListener('scroll', adjustCalculatorSidebarPosition);

    // Initial check in case the page loads and the condition is already met
    adjustCalculatorSidebarPosition();
});

function sendEstimate() {

    if (!$('#email').val()) {
        return;
    }

    var recommendationText = '';
    if ($('.mrk-first-radiator-qty').text() !== '') {
        recommendationText += $('.mrk-first-radiator-qty').text() + ' x ' + $('.mrk-first-radiator-name').text() + ' ';
    }
    if ($('.mrk-second-radiator-qty').text() !== '') {
        recommendationText += $('.mrk-second-radiator-qty').text() + ' x ' + $('.mrk-second-radiator-name').text();
    }

    var attr = {
        "str::email": $('#email').val(),
        "str::phone-number": window.iti ? window.iti.getNumber() : ($('#phone').val() || null),
        "str:cm:room-name": $('#room_name').val(),

        // calculator inputs
        "str:cm:room-type": $('#room-type option:selected').text(),
        "str:cm:postal-code": $('#postal-code').val(),
        "int:cm:room-length": $('#room-length').val() * 1000,
        "int:cm:room-width": $('#room-width').val() * 1000,
        "int:cm:room-total-size": $('#room-total-size').val() * 1000,
        "int:cm:room-height": $('#room-height').val() * 1000,
        "int:cm:no-of-windows": parseInt($('#no-of-windows').val()),
        "str:cm:size-of-windows": $('#size-of-windows option:selected').text(),
        "int:cm:size-of-windows-manual": $('#size-of-windows-manual').val() * 1000,
        "int:cm:external-walls": parseInt($('#external-walls').val()),
        "int:cm:external-walls-manual": $('#external-walls-manual').val() * 1000,
        "int:cm:no-of-external-doors": parseInt($('#no-of-external-doors').val()),
        "str:cm:walls-insulation": $('#walls-insulation option:selected').text(),
        "int:cm:custom-r-value-walls": $('#custom-r-value-walls').val() * 1000,
        "str:cm:ceilings-insulation": $('#ceilings-insulation option:selected').text(),
        "int:cm:custom-r-value-ceilings": $('#custom-r-value-ceilings').val() * 1000,
        "str:cm:floors-insulation": $('#floors-insulation option:selected').text(),
        "int:cm:custom-r-value-floors": $('#custom-r-value-floors').val() * 1000,
        "str:cm:windows-insulation": $('#windows-insulation option:selected').text(),
        "int:cm:custom-r-value-windows": $('#custom-r-value-windows').val() * 1000,
        "str:cm:room-draughty": $('#room-draughty option:selected').text(),
        "str:cm:room-carpet": $('#room-carpet option:selected').text(),
        "str:cm:room-floor": $('#room-flore option:selected').text(),

        // // results
        "str:cm:wattage-required": $('.final-watt-required').text(),
        "txt:cm:recommended-radiators": recommendationText,
    }

    ap3c.track({
        v: 0,
        email: $('#email').val() || null,
        first: $('#first_name').val() || null,
        last: $('#last_name').val() || null,
        phone: (window.iti ? window.iti.getNumber() : $('#phone').val()) || null,
    });
    ap3c.activity({
        "activity_id": "act:cm:submitted-calculator",
        // "fields": fields,
        "attributes": attr
    });

    // add first name etc. to attr
    attr["str::first-name"] = $('#first_name').val() || null;
    attr["str::last-name"] = $('#last_name').val() || null;
    attr["str::phone-number"] = (window.iti ? window.iti.getNumber() : $('#phone').val()) || null;
    attr["str::email"] = $('#email').val() || null;

    // add UTM keys & click ids from local storage
    UtmAdKeysToTrack.forEach((key) => {
        attr[`str::${key}`] = localStorage.getItem(key) || null;
    });

    // send submission to Zapier
    sendSubmissionToZapier(attr)

    // console.log('attr', attr);
    $('#successMessage').text('Thanks, we will email your estimate shortly.');
}


function sendSubmissionToZapier(attr) {
    // console.log('sendSubmissionToZapier')
    const url = 'https://mermaiddevs.com/shopify_apps/thermosoft_zapier_webhook.php';
    const data = JSON.stringify(attr);
    // console.log('data', data)
    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        contentType: 'application/json',
        success: function (response) {
            console.log('Success:', response);
        },
        error: function (error) {
            console.error('Error:', error);
        }
    });
}


// Handle both keyboard arrows and input spinner arrows
$('.mrk-input-step[type="number"]').on('keydown', function(e) {
    // Allow 2 decimal places but still keep the arrow up / arrow down to change by 0.1
    if (e.which === 38 || e.which === 40) {
        e.preventDefault();
        let currentValue = parseFloat($(this).val()) || 0;

        if (e.which === 38) { // Up arrow
            currentValue += 0.1;
        } else { // Down arrow
            currentValue -= 0.1;
        }

        // Ensure we don't go below 0 (if min is set)
        if ($(this).attr('min') && currentValue < parseFloat($(this).attr('min'))) {
            currentValue = parseFloat($(this).attr('min'));
        }

        $(this).val(currentValue.toFixed(2));
        $(this).trigger('change');
    }
});

// Custom spinner buttons - only attach events on desktop devices
if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $('.spinner-up').on('click', function(e) {
        e.preventDefault(); // Prevent form submission or other default behaviors
        e.stopPropagation(); // Stop event from bubbling up
        const input = $(this).closest('.Form__Item').find('input');
        let currentValue = parseFloat(input.val()) || 0;
        currentValue += 0.1;
        input.val(currentValue.toFixed(2));
        input.trigger('change');
    });

    $('.spinner-down').on('click', function(e) {
        e.preventDefault(); // Prevent form submission or other default behaviors
        e.stopPropagation(); // Stop event from bubbling up
        const input = $(this).closest('.Form__Item').find('input');
        let currentValue = parseFloat(input.val()) || 0;
        currentValue -= 0.1;

        // Ensure we don't go below min
        if (input.attr('min') && currentValue < parseFloat(input.attr('min'))) {
            currentValue = parseFloat(input.attr('min'));
        }

        input.val(currentValue.toFixed(2));
        input.trigger('change');
    });
}

// Optimize input fields for mobile devices
$('.mrk-input-step[type="number"]').each(function() {
    // Set proper attributes for mobile keyboards
    this.setAttribute('inputmode', 'decimal');
    this.setAttribute('pattern', '[0-9]*\\.?[0-9]*');
});

// Make sure the custom spinner is visible on mobile
// $(document).ready(function() {
//     // Always show spinners on mobile devices
//     if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
//         $('.Form__Item').each(function() {
//             const spinner = $(this).find('.mrk-custom-spinner');
//             if (spinner.length) {
//                 spinner.css('display', 'flex');
//             }
//         });
//     }
// });
// Close the jQuery-capture wrapper (see top of file). Prefer the theme's own
// jQuery; fall back to whatever global jQuery survives the app scripts.
})(window.jQuery || window.$);
